module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_green_07-dcd32688be28f4153ca33cafa280299b.svg";